module.exports = __webpack_public_path__ + "static/Apple-Podcasts-252800a7a18ef505cdf4c2f436ab8181.png";